// extracted by mini-css-extract-plugin
export default {"row":"StarRating_row__gXxfo","star":"StarRating_star__h1SIf","starButton":"StarRating_starButton__Wq+ys"};